
import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FaTrash } from 'react-icons/fa'
import type { DataField } from '..'
import { FormLabelCustom } from '../styles'
import { ModalDelete } from './components/ModalDelete'

interface AddressListProps {
  selectedId: number
  formData: DataField
  setFormData: React.Dispatch<React.SetStateAction<DataField>>
  getAllFields: () => Promise<void>
  formsData: DataField[]
}

export function AddressList({
  selectedId,
  formData,
  setFormData,
  getAllFields,
  formsData
}: AddressListProps){
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedField, setSelectedField] = useState<DataField | null>(null)

  const handelRemoveFieldFromState = (field: DataField) => {
    setFormData((prevState) => {
      const updatedList = prevState?.campos_relacionados.filter(
        (item) => !(item.ordem === field.ordem && item.titulo === field.titulo)
      );

      if (updatedList.length === 0) {
        return {
          ...prevState,
          campos_relacionados: []
        }
      };
  
      const firstOrder = Number(formData.ordem) + 1 || 1;
  
      const reorderedList = updatedList.map((item, index) => {
        return {
          ...item,
          ordem: (firstOrder + index).toString(),
        }
    });

      return {
        ...prevState,
        campos_relacionados: reorderedList
      };
    });

  }
  
  const handleRemoveAddressField =  (field: DataField) => {
    if(selectedId && field?.id){
      setShowModalCancel(true)
    } else {
      handelRemoveFieldFromState(field)
    }
  }

  const handleUpdateHelperText = (field: DataField, newValue: string) => {
    setFormData((state) => {
      return {
        ...state,
        campos_relacionados: state?.campos_relacionados?.map((item) => {
          if(item.ordem === field.ordem && item.titulo === field.titulo){
            return {
              ...item,
              texto_ajuda: newValue
            }
          }
          
          return item
        })
      }
    })
  }


  const addressListOrder =['Estado', 'Cidade', 'Bairro', 'Rua/Avenida']
  const fieldsNotInAddressList = addressListOrder.filter(
    (field) => !formData?.campos_relacionados?.some((item) => item.titulo === field)
  )

  const handleAddMissingAddressField = () => {
    setFormData((prevState) => {
      const fieldsNotInAddressList = addressListOrder.filter(
        (field) => !prevState?.campos_relacionados?.some((item) => item.titulo === field)
      );

      if (fieldsNotInAddressList.length === 0) return prevState;

      const isFirstRelatedField = prevState?.campos_relacionados.length === 0;
      let newParentOrder = Number(prevState.ordem);
      let firstOrder: number;

      if (isFirstRelatedField) {
        const maxOrder = formsData.reduce((max, field) => {
          const ordem = Number(field.ordem);
          return ordem > max ? ordem : max;
        }, 0);

        newParentOrder = maxOrder + 1;
        firstOrder = newParentOrder + 1;
      } else {
        firstOrder = Number(prevState?.campos_relacionados[0].ordem);
      }

      const newField = {
        ordem: (firstOrder + prevState?.campos_relacionados.length).toString(),
        titulo: fieldsNotInAddressList[0],
        texto_interno: '',
        formulario: prevState?.campos_relacionados[0]?.formulario || prevState.formulario || '',
        mascara: '',
        validador: '',
        tipo: 'CEP',
        texto_ajuda: `Informe o campo ${fieldsNotInAddressList[0].toLowerCase()}`,
        obrigatorio: true,
        alternativas: [],
        condicional_campos: [],
        limite_replicacoes: 0,
      };

      const updatedList = [...prevState?.campos_relacionados, newField].map((item, index) => ({
        ...item,
        ordem: (firstOrder + index).toString(),
      }));

      return {
        ...prevState,
        ordem: isFirstRelatedField ? newParentOrder.toString() : prevState.ordem,
        campos_relacionados: updatedList
      };
    });
  };
  
  
  return (
   <>
     {formData?.campos_relacionados
      ?.sort((a, b) => Number(a.ordem) - Number(b.ordem))
      ?.map((field) => (
      <div key={field.id}>
        <div className='row mt-3' >
        <Form.Group
          style={{ maxWidth: 86}}
          className="mb-3 col-md-3">
          <FormLabelCustom>Ordem</FormLabelCustom>
          <Form.Control
            placeholder="Ordem"
            readOnly
            style={{ 
              maxHeight: 38, 
              minWidth: 38, 
              textAlign: 'center'
            }}
            value={field.ordem}
          />
        </Form.Group>
        <Form.Group className="mb-3 col-md-3">
          <FormLabelCustom required>Título</FormLabelCustom>
          <Form.Control
            placeholder="Digite o título"
            value={field.titulo}
            readOnly
            disabled
          />
        </Form.Group>

          <Form.Group className="col-md-3">
            <FormLabelCustom required>Tipo do Campo</FormLabelCustom>
            <Form.Select
              placeholder='CEP'
              value={field.tipo}
              isInvalid={!field.tipo}
              required
              disabled
            >
              <option value="CEP">CEP</option>
              <option value="Texto">Texto</option>
              <option value="Numero">Número</option>
              <option value="Data">Data</option>
              <option value="Area">Area</option>
              <option value="Email">Email</option>
              <option value="Telefone">Telefone</option>
              <option value="Select">Select</option>
              <option value="Radio button">Radio button</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3 col-md-3">
          <FormLabelCustom required>Texto de ajuda</FormLabelCustom>
          <Form.Control
            placeholder="Digite o texto de ajuda"
            value={field.texto_ajuda}
            required
            onChange={(event) => {
              handleUpdateHelperText(field, event.target.value)
            }}
          />
          {field.texto_ajuda && 
            <Form.Control.Feedback type="invalid">
              Campo obrigatório
            </Form.Control.Feedback>
          }
        </Form.Group>
        {formData?.campos_relacionados?.length > 0 && (
          <div className='col-md-1 col-sm-12 text-center mt-4 pt-2'>
            <Button
              variant="text"
              className="border"
              disabled={isLoading}
              onClick={() => {
                setSelectedField(field)
                handleRemoveAddressField(field)
              }}
            >
              <FaTrash title="Remover este campo da lista"/>
            </Button>
          </div>
        )}
        </div>
      </div>
  ))}
   {fieldsNotInAddressList.length > 0 && (
      <div className='col-md-12 pb-4  my-2 pt-2'>
        <Button
          onClick={handleAddMissingAddressField}
        >
          Adicionar o campo {fieldsNotInAddressList[0].toLowerCase()}
        </Button>
      </div>
    )}
    {selectedField && (
      <ModalDelete
        selectedField={selectedField}
        setSelectedField={setSelectedField}
        showModalCancel={showModalCancel}
        setShowModalCancel={setShowModalCancel}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        handelRemoveFieldFromState={handelRemoveFieldFromState}
        getAllFields={getAllFields}
      />
    )}
   </>
  )
}